import React, { useState, useRef, useEffect } from 'react';
import './App.css';
import Fingerprint2 from 'fingerprintjs2';
import { API_URL } from './config';
import HorizontalMenu from './ButtonLink';

const ChatInput = React.forwardRef(({onSendMessage, userConversationId}, ref) => {
  //console.log("子组件收到的参数是:", userConversationId);
  const accumulatedTextRef = { current: "" }; // 后端传来的总文本
  const displayedTextRef = { current: "" };   // 界面已经显示的文本
  const [messages, setMessages] = useState([]);
  const [fingerprintOwn, setFingerprint] = useState("");
  const [productTypeOwn, setProductType] = useState("");
  const [inputText, setInputText] = useState('');
  const [isTextareaDisabled, setIsTextareaDisabled] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const textareaRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const conversationIdRef = useRef(null); // 存储 type: -1 的 ID
  const timerRef = useRef(null); // 1. 创建一个 Ref 用来存放定时器 ID

  const restorMessage = (message, bUser, answer ) => {
    setMessages(prevMessages => [...prevMessages, { text: message, isUser: bUser, answer: answer }]);
  };

  // 将子组件中的函数通过 ref 暴露给父组件
  React.useImperativeHandle(ref, () => ({
    ParentHandleSendMessage,
    childFunction
  }));

  const childFunction = () => {
    if(conversationIdRef.current){
        conversationIdRef.current = null;
      }
  };

  /**
   * 失去焦点
  */
  const handleBlur = () => {
    setIsFocused(false);
    //console.log('Textarea is blurred');
  };

  const handleFocus = (e) => {
    // 延迟执行是为了等待软键盘弹出完成
    setTimeout(() => {
      e.target.scrollIntoView({
        behavior: 'smooth', 
        block: 'center' // 将输入框滚动到屏幕中间，避免被输入法上边缘贴死
      });
    }, 300);
  };

  const enableInput = () => {
    setIsTextareaDisabled(false);
    setIsButtonDisabled(false);
     // 设置焦点到<textarea>
    if (textareaRef.current) {
      textareaRef.current.readOnly = false;
      //textareaRef.current.focus();
    }
  };

  const disableInput = () => {
    setIsTextareaDisabled(true);
    setIsButtonDisabled(true);
  };

  async function getFingerprint2() {
  return new Promise((resolve) => {
    Fingerprint2.get(function(components) {
      const queryParams = new URLSearchParams(window.location.search);
      const fingerprintTmp = queryParams.get("userId");
      setFingerprint(fingerprintTmp); // 如果你需要这个副作用
      resolve(fingerprintTmp); // 这才是真正的返回
    });
  });
}

  const adjustHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      if(inputText.length < 30){
        textarea.style.height = "48px"; // 先重置高度
      }else{
        textarea.style.height = "auto"; // 先重置高度
        textarea.style.height = `${textarea.scrollHeight}px`; // 根据内容调整高度
      }
    }
  };

  useEffect(() => {
    // 在组件渲染后，如果textarea不可用，则不设置焦点
    if (!isTextareaDisabled && textareaRef.current) {
      textareaRef.current.readOnly = false;
      //.current.focus();
    }
    getFingerprint2 ();
    adjustHeight();
    const queryParams = new URLSearchParams(window.location.search);
    const param = queryParams.get("param");
    const productType0 = queryParams.get("productType");
    console.log("param: " + param, "productType: " + productType0);
    setProductType(productType0);

  }, [isTextareaDisabled, productTypeOwn, userConversationId]);

  const handleInputChange = (e) => {
    setInputText(e.target.value);
    if(e.target.value.length > 30){
      e.target.style.height = 'auto'; // 重置高度以便重新计算
      e.target.style.height = `${e.target.scrollHeight}px`; // 设置高度为滚动高度
    }
    else{
      e.target.style.height = '48px';
    }
  };

  function callbackLogin(json) {
    try {
      let obj = window.JSON.parse(json);
      console.log(obj)
      if (obj.code === 200) {
        const dataReturnStr = obj.data.msg
        console.log(dataReturnStr)
        //console.log(id)
        restorMessage(dataReturnStr, false, obj.data);
        onSendMessage( dataReturnStr, false, false, obj.data);
      }
      else{
        console.log("error")
        onSendMessage(obj.msg.referAnswer, false, true);
        setMessages([])
      }
    } catch (error) {
      // 如果上面的操作抛出异常，这里的代码将会执行
      console.error('Error during data fetching:', error);
      onSendMessage("AI\n Error during data fetching:" + error, false, true);
    }
    enableInput()
  };

  function startRenderText(){
    // 如果当前已经有定时器在跑，先清除，防止出现多个定时器竞争
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    // 2. 将 setInterval 的返回值赋给 timerRef.current
    timerRef.current  = setInterval(() => {
      const total = accumulatedTextRef.current;
      const displayed = displayedTextRef.current;
      if (total.length > displayed.length) {
        // 每次根据剩余量动态决定步长，内容多时快一点，内容少时细水长流
        const step = Math.ceil(total.length  / 100) || 1; 
        const nextText = total.substring(displayed.length, displayed.length + step);
        
        displayedTextRef.current += nextText;
        onSendMessage(nextText, false, false, null, 1, null);
      } else if (total.length > 0 && total.length === displayed.length) {
        // --- 关键判断：请求结束了，且字也打完了，才清理 ---
        clearInterval(timerRef.current);
        console.log("所有内容显示完毕，定时器关闭");
      }
    }, 40); // 40ms 刷新率，视觉非常平滑

  }
  

  const handleSendPost = async (paramBody, messageAll,fingerprint, callback, strType = "") =>
  {
    let strData = {
			question: paramBody,
      userId: fingerprint,
      productType: productTypeOwn,
		};
    if(strType !== ""){
      strData.productType = strType;
    }
    if(conversationIdRef.current){
      strData.userConversationId = conversationIdRef.current;
    }
    if(userConversationId){
      strData.userConversationId = userConversationId;
    }
    
    let json = JSON.stringify(strData)
    console.log("json: " + json)
    startRenderText();
    console.log("开始开启定时器...");
    try {
      let getData = false;
      const startTime = performance.now(); // 获取高精度开始时间
      const response = await fetch(`${API_URL}/getAnswer/v2`, {
        method: 'POST', // 1. 指定请求方法
        headers: {
          'Content-Type': 'application/json', // 2. 告诉后端你发送的是 JSON
          "Accept": "application/json" 
        },
        body: json
      });
      const endTime = performance.now(); // 获取结束时间
      const timeTaken = endTime - startTime;
      if(getData === false){
        console.log(`请求耗时: ${timeTaken} 毫秒`);
        getData = true;
      }
      
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      onSendMessage('', false, false, null, 0);
      // 提前准备一个缓冲区，防止数据包被截断导致的解析失败
      let buffer = ''; 
     
      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          // 2. 结束后，确保缓冲区剩余内容全部渲染
          //onSendMessage(bufferText, false, false, null, 1);
          break;
        }
       
        // 解码并合并到缓冲区
        buffer += decoder.decode(value, { stream: true });

        // 按换行符分割，处理每一行
        const lines = buffer.split('\n');
        
        // 最后一行可能不完整，保留到下一次循环处理
        buffer = lines.pop(); 
        console.log("Received value:", lines);
        // console.log("Received chunk:", lines);
        for (let line of lines) {
          const trimmedLine = line.trim();
          if (!trimmedLine || !trimmedLine.startsWith('data:')) continue;

          try {
            const jsonStr = trimmedLine.replace('data:', '').trim();
            const parseData = JSON.parse(jsonStr);
            
            // --- 核心逻辑：判断数据流结束 ---
            if (parseData.data === null) {
              console.log("收到结束信号：", parseData.msg);
              return; // 终止函数，停止后续处理
            }

            const innerData = parseData.data;

            switch (innerData.type) {
              case -1: // 会话 ID
                conversationIdRef.current = innerData.userConversationId;
                break;

              case 0: // 问答内容
                  if(innerData.type === 0 && typeof innerData.answer === 'string') {
                    const textChunk = innerData.answer;
                    if (textChunk) {
                      accumulatedTextRef.current += textChunk;
                    }
                  }
                break;
              case 1: // 调参
                console.log('处理调参逻辑');
                //data.answer:ai回答
                // data.strategy:策略对应的id(1,2,3,4...)
                //data.earSide: 左右耳
                let serverAudioParams = {
                  strategy: innerData.strategy,
                  earSide: innerData.earSide,
                  value: innerData.value
                };
                //console.error('解析JSON数据', serverAudioParams);
                onSendMessage(innerData.answer, false, false, null, 2, serverAudioParams);
                break;
            }
          } catch (err) {
            console.error('解析单行JSON失败', err);
          }
        }
      }
    } catch (error) {
      console.error("流传输错误", error);
    } finally {
      //clearInterval(renderTimer);
    }

  }

  const handleSendMessage = () => {
    if (inputText.trim() !== '') {
      clearInterval(timerRef.current);
      restorMessage(inputText, true);
      onSendMessage(inputText, true);
      setInputText('');
      let lastFourMessages = messages;
      if (messages.length >= 7){
        lastFourMessages = messages.slice(-2);
      }
      
      let messageAll = ""
      lastFourMessages.map((msg, index) => (
        messageAll += msg.text +"\n"
      ))
      handleSendPost(inputText, messageAll, fingerprintOwn, callbackLogin)
      disableInput()
    }
  };

  const ParentHandleSendMessage = (inputValue, productType0) => {
    setProductType(productType0);
    getFingerprint2 ()
    .then(fingerprint => {
      console.log("parent call", productType0, fingerprint)
      if (inputValue.trim() !== '') {
        restorMessage(inputValue, true);
        onSendMessage(inputValue, true);
        setInputText('');
        let lastFourMessages = messages;
        if (messages.length >= 7){
          lastFourMessages = messages.slice(-2);
        }
        
        let messageAll = ""
        lastFourMessages.map((msg, index) => (
          messageAll += msg.text +"\n"
        ))
        handleSendPost(inputValue, messageAll, fingerprint, callbackLogin, productType0)
        disableInput()
      }
    })
    .catch(error => {
      console.error("Error:", error);
    });
    
  };

  

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // 阻止默认的 Enter 键行为（比如换行）
      handleSendMessage();
      e.target.style.height = '48px';
    }
  };

  const [btnStyle, setBtnStyle] = useState({
    width: '100px',
    height: '30px',
    marginLeft: '20px',
    borderRadius: '8px'
  });

  // 步骤 1: 定义父组件中的处理函数
  const handleMenuClick = (actionName) => {
    console.log(`动作名称是: ${actionName}`);
    const inputValue = "Start Sound Tuning"
    restorMessage(inputValue, true);
    onSendMessage(inputValue, true);
    setInputText('');
    let lastFourMessages = messages;
    if (messages.length >= 7){
      lastFourMessages = messages.slice(-2);
    }
    
    let messageAll = ""
    lastFourMessages.map((msg, index) => (
      messageAll += msg.text +"\n"
    ))
    handleSendPost(inputValue, messageAll, fingerprintOwn, callbackLogin, productTypeOwn)
    disableInput()
  };

  return (
    <div className="chat-input-out">
      <HorizontalMenu onMenuClick={handleMenuClick} />
      <div className="chat-input">
        <div className="text-container">
          <textarea className='textarea-css'
            //disabled={isTextareaDisabled}
            cols="100"
            ref={textareaRef}
            placeholder="Type your message..."
            value={inputText}
            onKeyDown={handleKeyDown}
            onChange={handleInputChange}
                    onBlur={handleBlur}
                    onFocus={handleFocus}
          />

          <button  className='send-button'
            onClick={handleSendMessage}
            //disabled={isButtonDisabled}
            >
          </button>
        </div>
        
      </div>
      <div className='chat-tips-div'>Responses are generated by AI</div>
    </div>
  );
});

export default ChatInput;
